export default {
  name: "DsfTextProxy",
  functional: true,
  inject: {
    $vm: {
      default: null
    }
  },
  render(h, _vm) {
    var _c = _vm._c || h;
    var injections = _vm.injections;
    _vm.$vm = injections.$vm;
    let value = _vm.data.model ? _vm.data.model.value : "";
    let domProps = "innerText";
    let currentValueIsHtml = false;
    let labelNode = null; //_vm._e();
    let iconNode = null; //_vm._e();
    let isPre = _vm?.data?.attrs?.isPre || false;
    let icon = _vm?.data.attrs?.textProxyIcon || "";
    let isJustify = false;
    let htmlTitle = "";
    if (icon) {
      icon = icon.replace(/^icon-/g, "");
      if (icon) {
        iconNode = _c("i", {
          staticClass: `proxy-conent proxy-icon iconfont ${"icon-" + icon}`,
          class: [getCode(_vm, "icon")]
        });
      }
    }
    if (_vm.data.attrs.showLabel && _vm.data.attrs.label) {
      labelNode = _c(
        "span",
        {
          staticClass: "proxy-conent proxy-label",
          class: [getCode(_vm, "label")]
        },
        [_vm._v(_vm._s(_vm.data.attrs.label + ":"))]
      );
    }
    //如果是分散对齐
    if (_vm.data.attrs.inputAlign == "justify") {
      isJustify = true;
      domProps = "innerHTML";
    }
    //如果值位过滤器开头，则使用innerHTML
    if (_vm.data?.attrs?.formatter?.indexOf?.("html") === 0) {
      domProps = "innerHTML";
      currentValueIsHtml = true;
    }
    if (currentValueIsHtml) {
      value = dsf.safe.xss(value);
      htmlTitle = getHTMLText(value);
    } else {
      //富文本框内容，后端给过来是一个html
      if (_vm.data.attrs.valueIsHtml) {
        value = dsf.safe.xss(value);
        htmlTitle = getHTMLText(value);
      } else {
        htmlTitle = value;
      }
    }
    let valueStr = "";
    if (dsf.isUnDef(value) || value === "") {
      value = _vm?.data?.attrs?.emptyPlaceholder || "";
    }
    //当值为空时，显示空数据占位符
    // if (dsf.isUnDef(value) || value === "") {
    //   valueStr = _vm?.data?.attrs?.emptyPlaceholder || "";
    // } else {
    //   //格式化值
    //   valueStr = _vm._s($dataFormat("proxy", _vm.data.attrs.formatter, value));
    //   //追加值后缀
    //   if (valueStr && _vm?.props?.metadata?.ckey == "text-meta-data" && _vm.props?.append) {
    //     valueStr = valueStr + _vm.props.append;
    //   }
    // }

    if (dsf.isDef(value) && value !== "") {
      //格式化值
      valueStr = _vm._s($dataFormat("proxy", _vm.data.attrs.formatter, value));
      //追加值后缀
      if (valueStr && _vm?.props?.metadata?.ckey == "text-meta-data" && _vm.props?.append) {
        valueStr = valueStr + _vm.props.append;
      }
    }
    if (!isPre && valueStr) {
      valueStr = valueStr.replaceAll(/\n|\r\n/g, "");
    }
    //分散对齐
    if (isJustify) {
      valueStr = _vm._s($dataFormat("proxy", "htmlJustify", valueStr));
    }

    let valueNode = _c("span", {
      staticClass: "proxy-conent",
      class: [getCode(_vm, "value"), isPre ? "ds-text-pre" : ""],
      attrs: {
        title: $dataFormat("proxyTitle", _vm.data.attrs.formatter, htmlTitle)
      },
      domProps: {
        [domProps]: valueStr
      }
    });
    let cls = _vm.data.class;
    if (cls) {
      if (dsf.isString(cls)) {
        cls = [cls];
      } else if (dsf.isObject(cls)) {
        cls = _.map(cls, (v, k) => (v ? k : ""));
      }
    } else {
      cls = [];
    }
    let listeners = _vm.listeners;
    let span = _c(
      "span",
      {
        ..._vm.data,
        attrs: {
          id: _vm.data.attrs.id
        },
        class: [
          "proxy-text",
          isJustify ? "text-align-justify" : "",
          ...(_vm.data.class || []),
          _vm.data.attrs.visible === false ? "ds-hide" : "",
          getCode(_vm)
        ],
        on: {
          click(e) {
            clickDefaultHanlder(e, _vm);
          },
          ...listeners
        }
      },
      [iconNode, labelNode, valueNode]
    );
    return span;
  }
};

function clickDefaultHanlder(e, _vm) {
  let grid = $(e.currentTarget).closest(".ds-datagrid");
  if (grid.length > 0) {
    let gridVue = grid.get(0).__vue__;
    if (gridVue) {
      let buttonbarEl = null;
      if (gridVue.operateColumn && gridVue.operateColumn.show) {
        let tbody = grid.find(".el-table__body:eq(0)");
        let tr = tbody.find(`tr:eq(${_vm.props.local.$index})`);
        buttonbarEl = $(tr).find("div.operate-column[ctrl_type='dsf.buttonbar']");
      } else {
        buttonbarEl = $(gridVue.$el).find(
          "div[ctrl_type='dsf.buttonbar'][row-hash='" + _vm.props.local.$hash + "']"
        );
      }
      if (buttonbarEl && buttonbarEl.length > 0) {
        let buttonbar = buttonbarEl.get(0).__vue__;
        let targetButtons = _.filter(buttonbar.buttons, (btn) => {
          return btn.linkBind == _vm.props.designId;
        });
        targetButtons.length > 0 && buttonbar.triggerButtonClick(targetButtons[0]);
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }
}

function $dataFormat(k, params, v) {
  if (params) {
    let filter = dsf.global.Vue.filter(k);
    if (filter) {
      return filter(v, params);
    }
  }
  return v;
}

function getCode(_vm, suffix) {
  if (_vm) {
    let code = _vm.data.attrs.metadata_fullcode || _vm.data.caption;
    if (code) {
      return code.replace(/\./g, "_") + (suffix ? "__" + suffix : "");
    }
  }
  return "";
}

function getLabelWidth(_vm) {
  if (_vm.injections?.$vm?.$page) {
    return _vm.injections?.$vm?.$page?.formItemLabelWidth || _vm?.labelWidth || 120;
  }
  return 0;
}

function getLabelWidthStyle(_vm) {
  let showLable = _vm.data.attrs.showLabel;
  if (showLable) {
    let labelWidth = getLabelWidth(_vm);
    if (labelWidth) {
      return {
        width: labelWidth + "px"
      };
    }
  }
  return {};
}

function getFormItemBlockMarginLeft(_vm) {
  let labelWidth = getLabelWidth(_vm);
  let showLable = _vm.data.attrs.showLabel;
  if (labelWidth && showLable) {
    return {
      "margin-left": labelWidth + "px"
    };
  }
  return {};
}
let div = null;
function getHTMLText(html) {
  if (!div) {
    div = document.createElement("div");
  }
  div.innerHTML = html;
  return div.innerText;
}

// let reg_html = /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i;
// function isHtml(input) {
//   reg_html.lastIndex = 0;
//   return reg_html.test(input);
// }
